import React, { useRef } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import useVisibility from 'hooks/useVisibility';

const getStyles = ({ height }) => ({ minHeight: `${height}px`, height });

const LazyLoad = ({
  height = 50,
  offset = 200,
  isTable = false,
  children,
  isDragging = false,
  once,
  isTurnedOff = false,
  ...props
}) => {
  const viewportRef = useRef();
  const isVisible = useVisibility(
    viewportRef,
    { rootMargin: `0px 0px ${offset}px 0px` },
    {
      isDeferred: isDragging,
      once,
    },
  );

  if (isTurnedOff) {
    if (_.isFunction(children)) {
      return children();
    }

    return children;
  }

  // Need to pass `ref` for using with `once = false`
  if (isVisible) {
    if (_.isFunction(children)) {
      return children(viewportRef);
    }

    return children;
  }

  if (isTable) {
    return <tr className="flex" ref={viewportRef} style={getStyles({ height })} {...props} />;
  }

  return <div className="flex" ref={viewportRef} style={getStyles({ height })} {...props} />;
};

LazyLoad.propTypes = {
  height: PropTypes.number,
  offset: PropTypes.number,
  isTable: PropTypes.bool,
  isDragging: PropTypes.bool,
  isTurnedOff: PropTypes.bool,
  once: PropTypes.bool,
};

export default LazyLoad;
